import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// ----- Imports ----- //
import { cmp } from '@guardian/consent-manager';
import { ButtonLink, Link, themeLinkBrand, } from '@guardian/source/react-components';
import { Children } from 'react';
import { copyrightNotice, guardianContactUsLink, privacyLink, } from 'helpers/legal';
import Rows from '../base/rows';
import { BackToTop } from './BackToTop';
import FooterContent from './containers/FooterContent';
import { backToTopLink, componentFooter, copyright, link, linksList, } from './footerStyles';
// ----- Component ----- //
function Footer({ centred, children, termsConditionsLink, fullWidth, }) {
    function showPrivacyManager() {
        cmp.showPrivacyManager();
    }
    return (_jsxs("footer", { id: "qa-footer", css: componentFooter, role: "contentinfo", children: [Children.count(children) > 0 && (_jsx(FooterContent, { appearance: {
                    border: true,
                    paddingTop: true,
                    centred,
                    fullWidth,
                }, children: _jsx("div", { children: _jsx(Rows, { children: children }) }) })), _jsx(FooterContent, { appearance: {
                    border: true,
                    centred,
                    fullWidth,
                }, children: _jsxs("ul", { css: linksList, children: [_jsx("li", { css: link, children: _jsx(Link, { href: "https://manage.theguardian.com/help-centre", theme: themeLinkBrand, children: "Help Centre" }) }), _jsx("li", { css: link, children: _jsx(Link, { href: guardianContactUsLink, theme: themeLinkBrand, children: "Contact us" }) }), _jsx("li", { css: link, children: _jsx(Link, { subdued: true, href: privacyLink, theme: themeLinkBrand, children: "Privacy Policy" }) }), _jsx("li", { css: link, children: _jsx(ButtonLink, { onClick: showPrivacyManager, theme: themeLinkBrand, children: "Privacy Settings" }) }), termsConditionsLink && (_jsx("li", { css: link, children: _jsx(Link, { href: termsConditionsLink, theme: themeLinkBrand, children: "Terms & Conditions" }) }))] }) }), _jsxs(FooterContent, { appearance: {
                    centred,
                    fullWidth,
                }, children: [_jsx("div", { css: backToTopLink, children: _jsx(BackToTop, {}) }), _jsx("span", { css: copyright, children: copyrightNotice })] })] }));
}
// ----- Default Props ----- //
Footer.defaultProps = {
    centred: false,
    fullWidth: false,
    termsConditionsLink: '',
    children: [],
}; // ----- Exports ----- //
export default Footer;
